<script>
export default {
  computed: {
    dictionarUI () {
      return this.$store.getters['dictionar/ui']
    }
  },
  methods: {
    translateUI (term, language) {
      /* eslint-disable no-mixed-operators */
      return this.dictionarUI && this.dictionarUI[term] && this.dictionarUI[term][language] || term
    }
  }
}
</script>
